import { defineComponent as _defineComponent } from 'vue'
import { computed, CreateElement, onMounted, RenderContext } from 'vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useI18n } from '@/helpers/composables/useI18n';
import { PopoverHelper } from '@/helpers/vfm/popover-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisclaimerButton',
  props: {
    price: { default: '' },
    disclaimerText: null
  },
  setup(__props: any) {

const props = __props as { price: string, disclaimerText?: string };



const { country } = storeToRefs(useLanguageStore());

const acceptedCountries = ['MX', 'DE', 'US', 'CA', 'AU', 'UK', 'GB', 'IE', 'NZ', 'ZA'];

const showDisclaimer = computed(() => acceptedCountries.includes(country.value) || props.disclaimerText != null);

const { t, tc } = useI18n();

onMounted(() => {
	if (process.env.NODE_ENV === 'development' && !props.price && !props.disclaimerText) {
		// unable to enforce this on components with optional prop unions. will reapproach this with Vue 3.4+
		console.error(
			'DisclaimerButton: No price or disclaimerText provided. ATV+ disclaimerText will be rendered without price by default.'
		);
	}
});

async function openDisclaimer(event: Event) {
	let scrollHandler: (() => void) | null = null;

	PopoverHelper.create({
		props: {
			escToClose: true,
			hideOverlay: true,
			lockScroll: false,
		},
		slotId: 'disclaimer-popover',
		popoverProps: {
			cssClass: 'disclaimer-popover',
			boundingElement: event.currentTarget,
			enableArrow: true,
		},
		component: {
			render: (h: CreateElement, context: RenderContext) => {
				if (props.disclaimerText) {
					return h('div', { class: 'disclaimer-text' }, [h('span', props.disclaimerText)]);
				}

				return h('div', { class: 'disclaimer-text' }, [
					h('span', tc('WEBAPP_APPLE_DISCLAIMER_TEXT')),
					h('span', t('WEBAPP_APPLE_DISCLAIMER_SUB_TEXT', { price: props.price }) as string),
				]);
			},
		},
		onOpened: () => {
			// Close popover when user scrolls
			scrollHandler = () => {
				if (process.client) {
					import('@/helpers/vfm/vfm-helper').then(({ VFMHelper }) => {
						VFMHelper.closeById('disclaimer-popover');
					});
				}
			};
			window.addEventListener('scroll', scrollHandler, { passive: true });
		},
		onClosed: () => {
			// Clean up scroll listener
			if (scrollHandler) {
				window.removeEventListener('scroll', scrollHandler);
				scrollHandler = null;
			}
		},
	});
}

return { __sfc: true,props, country, acceptedCountries, showDisclaimer, t, tc, openDisclaimer }
}

})